import React, { FC } from 'react';
import { Theme, IconButton, Tooltip, styled, Badge, BadgeProps } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';
import { currentEnv } from 'src';
import SpeechBubbleTooltip from 'src/components/SpeechBubbleTooltip/SpeechBubbleTooltip';
import { ToolboxAction } from './types';
import { getToolboxContent } from './TrajectoryToolboxTooltip';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type BadgeType = {
  badgeContent: BadgeProps['badgeContent'];
  color: BadgeProps['color'];
} | null;

export type TrajectoryToolboxButtonProps = {
  tooltip: string;
  active?: boolean;
  onClick?: (event: null | React.MouseEvent<HTMLElement>) => void;
  id?: string;
  icon: SpriteIcon;
  hasNotifications?: number;
  badge?: BadgeType;
  isBlockedForDemo?: boolean;
  type?: ToolboxAction | undefined;
};

const StyledIconButton = styled(IconButton)<Theme>(({ theme }) => ({
  borderRadius: theme.config.defaultBorderRadius,
  padding: theme.spacing(1),

  '& .MuiIconButton-label svg': {
    color: theme.palette.secondary.main,
  },
  '&:hover': {
    background: 'transparent',
    '& .MuiIconButton-label svg': {
      color: theme.palette.primary.main,
    },
  },
  '&.active': {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
    '& .MuiIconButton-label svg': {
      color: theme.palette.primary.main,
    },
  },
}));

const TrajectoryToolboxButton: FC<TrajectoryToolboxButtonProps> = ({
  active = false,
  onClick,
  tooltip,
  id,
  icon,
  badge,
  isBlockedForDemo,
  type,
}) => {
  const showPresentationMode = useAppSelector((state) => state.presentationMode.showPresentationMode);
  const button = (
    <StyledIconButton
      onClick={isBlockedForDemo ? () => {} : onClick}
      id={id}
      className={active ? 'active' : undefined}
    >
      <Badge overlap="rectangular" {...badge}>
        <FontAwesomeSpriteIcon icon={icon} iconSize="lg" isDisabled={isBlockedForDemo} />
      </Badge>
    </StyledIconButton>
  );
  if (currentEnv === 'demo') {
    return (
      <SpeechBubbleTooltip placement="left-end" title={getToolboxContent(type, showPresentationMode)}>
        {button}
      </SpeechBubbleTooltip>
    );
  }
  return (
    <Tooltip placement="left" title={tooltip}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default TrajectoryToolboxButton;
